export interface IReportDefinition {
  reportId: string;
  defaultPageName: string;
}

export interface IReportDefinitions {
  [areaName: string]: IReportDefinition;
}

export class IConfigData {
  myAccountUrl: string;
  logoutUrl: string;
  identityProviderBaseUrl: string;
}

export interface IConfigurationService {
  getConfigs(): Promise<IConfigData>;
  getWindowOrigin(): string;
}

export class ConfigurationService implements IConfigurationService {
  private static configs: IConfigData;
  async getConfigs() {
    if (ConfigurationService.configs) return Promise.resolve(ConfigurationService.configs);

    const data = await fetch(`${this.getWindowOrigin()}/Home/Config`, { credentials: 'include' });

    try {
      const jsonConfig = await data.json();
      ConfigurationService.configs = jsonConfig;
      return ConfigurationService.configs;
    } catch (ex) {
      return {
        logoutUrl: '',
        myAccountUrl: '',
        identityProviderBaseUrl: '',
      };
    }
  }

  getWindowOrigin(): string {
    if (process.env.NODE_ENV === 'development') {
      return 'https://localhost:' + process.env.REACT_APP_DEV_PORT;
    } else if (process.env.NODE_ENV === 'production') {
      if (!window.location.origin) {
        (window.location as any).origin =
          window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      }
    }
    return window.location.origin;
  }
}
